import { Component, OnInit } from '@angular/core';
import 'style-loader!./app.scss';
import { ChannelService } from './theme/services/channel.service';
import { LanguageService } from './theme/services/language.service';
import { Task } from './theme/models/user.model';

@Component({

	selector: 'app',
	template: `
	<div class="mainPageContainer mainPage">
		<div class="imgBgContainer" >
			<img *ngIf="initials.source=='bennet' || initials.source=='drive'" class="bg" src="./assets/img/bg_registration.jpg" alt="background" />
	<!--		<img *ngIf="initials.source=='bennet-new' || initials.source=='tablet-new' || initials.source=='totem-new' || initials.source=='drive-new'" class="bg" src="./assets/img/bg_new_registration2.png" alt="background" /> -->
		</div>
		<router-outlet></router-outlet>	
	</div>
	`
})
export class AppComponent implements OnInit {
	private initials = {
		source: "",
		lang: "",
		nexturl: ""
	}

	constructor(
		protected _channelService: ChannelService,
		protected _langService: LanguageService,
	) {
		//  Extract URL Search Parameters  
		var Params = window.location.search.slice(1).split('&');
		for (var p in Params) {
			var pairs = Params[p].split('=');
			if (pairs.length == 2)
				this.initials[pairs[0]] = pairs[1];

			this.initials.source = this._channelService.setSource(this.initials.source)
			this._channelService.setTask( (this.initials.source == "tablet" || this.initials.source == "tablet-new") ? Task.RichiediBC : Task.Registration)
		}
	}
	public ngOnInit() {
	//	console.log(this.initials)
		this._langService.setLanguage(this.initials.lang);
		this._channelService.setNextUrl(this.initials.nexturl,this.initials.source);
		console.time("fromAPPtoREG");
		// self.addEventListener('message', (event) => {console.log(event)});

	}



}



// WEBPACK FOOTER //
// ./src/app/app.component.ts